import { render, staticRenderFns } from "./CustomTreeView.vue?vue&type=template&id=2f36c7a6&"
import script from "./CustomTreeView.vue?vue&type=script&lang=js&"
export * from "./CustomTreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports